var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nav / prev_disabled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-/-prev_disabled",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#DFEBF4",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16 L12,16 C11.4477153,16 11,15.5522847 11,15 L11,9 L11,9",
    id: "Path",
    stroke: "#DFEBF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(14.500000, 12.500000) rotate(-315.000000) translate(-14.500000, -12.500000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevDisabled);
export default __webpack_public_path__ + "static/media/prev_disabled.c0925f1f97fc7c5fe78ebcc5f9cf96ff.svg";
export { ForwardRef as ReactComponent };